import {ColumnType, FilterableColumn} from 'src/tracker/model/column/tracker-column'
import { weaponVariantProperty } from '../../property/static/weapon-variant-property'
import { WeaponVariant } from 'src/forecast/model/universal-data-model'

export const weaponVariantColumn = new FilterableColumn<WeaponVariant>(
  "45px",
  ColumnType.WEAPON,
  weaponVariantProperty,
)
